import React from 'react'
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer'

// Styles mirror PickList.jsx (single-vehicle pick list) for visual
// consistency between the two PDFs.
const styles = StyleSheet.create({
  page: { padding: 24, fontSize: 12, fontFamily: 'Helvetica' },
  title: { fontSize: 16, marginBottom: 12, textAlign: 'center' },

  table: { display: 'table', width: 'auto', marginBottom: 20 },
  tableRow: { flexDirection: 'row' },
  tableColHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: '#eee',
    padding: 4,
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 4,
  },
  tableCellHeader: { fontWeight: 'bold' },
})

// One row per aggregated item across the whole fleet, instead of PickList's
// one row per item on a single vehicle - a shelf-picking list, not a
// per-vehicle checklist.
const ConsolidatedPickList = ({ entries = [] }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>Consolidated Pick List</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Item</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Size</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Total Needed</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Vehicles / Bags</Text>
          </View>
        </View>

        {entries.map((entry, i) => (
          <View style={styles.tableRow} key={i}>
            <View style={styles.tableCol}>
              <Text>{entry.name}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{entry.size || ''}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{entry.total}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>
                {entry.sources.map((s) => `${s.label} (${s.missing})`).join(', ')}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </Page>
  </Document>
)

export default ConsolidatedPickList
